if (!customElements.get('ats-color-selector')) {
  customElements.define(
    'ats-color-selector',
    class AtsColorSelector extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        if (!this.dataset.productTags.includes('colori-ats')) return;

        this.productId = this.dataset.productId;
        this.productTags = this.dataset.productTags;
        this.storageKey = `ats-color-selection-${this.productId}`;
        this.colorTableUrl = this.dataset.colorTableUrl;
        this.colorData = null;

        // UI Elements
        this.inputGroup = this.querySelector('.ats-input-group');
        this.colorInputDisplay = this.querySelector('.ats-color-display');
        this.colorInputReal = this.querySelector('.ats-color-real');
        this.surchargeInput = this.querySelector('.ats-surcharge-variant-id');
        this.selectedPreview = this.querySelector('.ats-selected-preview');
        this.toggleBtn = this.querySelector('.ats-toggle-btn');
        this.clearBtn = this.querySelector('.ats-clear-btn');
        
        // Modal Elements
        this.modalOverlay = this.querySelector('.ats-modal-overlay');
        this.modalCloseBtn = this.querySelector('.ats-modal-close');
        this.colorsContainer = this.querySelector('.ats-colors-container');

        this.initialize();
      }

      async initialize() {
        this.setupEventListeners();
        
        if (window.AtsPriceManager) {
            window.AtsPriceManager.init();
        }

        try {
          await this.fetchColorData();
          
          // Appena i dati sono pronti, controlla lo stato corrente delle varianti
          const currentVariant = this.getCurrentVariantValue();
          console.log('ATS Selector: Init - Current Variant:', currentVariant);
          this.handleVariantChange(currentVariant);
          
          this.restoreSelection();
        } catch (error) {
          console.error('ATS Color Selector: Init failed', error);
          this.toggleBtn.textContent = 'Errore caricamento dati';
        }
      }

      async fetchColorData() {
        if (this.colorData) return;
        const response = await fetch(this.colorTableUrl);
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        this.colorData = await response.json();
      }

      getCurrentVariantValue() {
        const variantSelector = this.closest('.product-variant-selects');
        if (!variantSelector) return '';

        const selectedElements = variantSelector.querySelectorAll('input:checked, option:checked');
        return Array.from(selectedElements).map(el => el.value).join(' ');
      }

      setupEventListeners() {
        this.toggleBtn.addEventListener('click', () => this.openModal());
        this.modalCloseBtn.addEventListener('click', () => this.closeModal());
        this.modalOverlay.addEventListener('click', (e) => {
          if (e.target === this.modalOverlay) this.closeModal();
        });

        this.clearBtn.addEventListener('click', () => this.clearSelection());

        this.colorsContainer.addEventListener('click', (e) => {
          const swatch = e.target.closest('.ats-color-swatch');
          if (swatch) {
            this.selectColor(swatch.dataset.code);
            this.closeModal();
          }
        });

        document.addEventListener('ats:variant-change', (e) => {
            const variantValue = e.detail.variantValue;
            this.handleVariantChange(variantValue);

            const currentColor = this.colorInputReal.value;
            if (currentColor) {
                this.updateSurcharge(currentColor);
            }
        });
      }

      handleVariantChange(variantValue) {
        if (!this.colorData) return;

        // Condizione 1: ats-solo-chiari su 14 LT
        const hasSoloChiariTag = this.productTags.includes('ats-solo-chiari');
        const is14LT = variantValue && variantValue.includes('14 LT');

        // Condizione 2: ats-solo-chiari-075 su 0.75 LT
        const hasSoloChiari075Tag = this.productTags.includes('ats-solo-chiari-075');
        const is075LT = variantValue && (variantValue.includes('0.75 LT') || variantValue.includes('0,75 LT'));

        // Condizione 3: ats-solo-chiari-2_5 su 2.5 LT
        const hasSoloChiari25Tag = this.productTags.includes('ats-solo-chiari-2_5');
        const is25LT = variantValue && (variantValue.includes('2.5 LT') || variantValue.includes('2,5 LT'));

        // Condizione 4: ats-solo-chiari-5 su 5 LT
        const hasSoloChiari5Tag = this.productTags.includes('ats-solo-chiari-5');
        const is5LT = variantValue && variantValue.includes('5 LT');

        console.log(`ATS Selector Check: 
            Tag14=${hasSoloChiariTag}, is14LT=${is14LT}
            Tag075=${hasSoloChiari075Tag}, is075LT=${is075LT}
            Tag25=${hasSoloChiari25Tag}, is25LT=${is25LT}
            Tag5=${hasSoloChiari5Tag}, is5LT=${is5LT}
            Variant=${variantValue}`);

        const shouldFilter = (hasSoloChiariTag && is14LT) || 
                             (hasSoloChiari075Tag && is075LT) ||
                             (hasSoloChiari25Tag && is25LT) ||
                             (hasSoloChiari5Tag && is5LT);

        if (shouldFilter) {
            console.log('ATS Selector: Filtering for BIANCO/BIANCHI');
            const filteredColors = this.colorData.filter(c => 
                c.bucket === 'BIANCO' || c.bucket === 'BIANCHI'
            );
            this.renderColors(filteredColors);

            const currentColorCode = this.colorInputReal.value;
            if (currentColorCode) {
                const isValid = filteredColors.some(c => c.code === currentColorCode);
                if (!isValid) {
                    this.clearSelection();
                }
            }
        } else {
            console.log('ATS Selector: Showing ALL colors');
            this.renderColors(this.colorData);
        }
      }

      renderColors(dataToRender) {
        const data = dataToRender || this.colorData;
        if (!data) return;

        const grouped = data.reduce((acc, color) => {
          const key = color.tonalita || 'ALTRO';
          if (!acc[key]) acc[key] = [];
          acc[key].push(color);
          return acc;
        }, {});

        this.colorsContainer.innerHTML = '';

        const sortedKeys = Object.keys(grouped).sort();

        if (sortedKeys.length === 0) {
            this.colorsContainer.innerHTML = '<p style="text-align:center; padding: 20px;">Nessun colore disponibile per questa selezione.</p>';
            return;
        }

        sortedKeys.forEach(tonalita => {
          const section = document.createElement('div');
          section.className = 'ats-tonalita-section';
          
          const title = document.createElement('div');
          title.className = 'ats-tonalita-title';
          title.textContent = tonalita;
          section.appendChild(title);

          const grid = document.createElement('div');
          grid.className = 'ats-color-grid';

          grouped[tonalita].forEach(color => {
            const swatch = this.createSwatchElement(color);
            grid.appendChild(swatch);
          });

          section.appendChild(grid);
          this.colorsContainer.appendChild(section);
        });
      }

      createSwatchElement(color) {
        const swatch = document.createElement('div');
        swatch.className = 'ats-color-swatch';
        swatch.dataset.code = color.code;
        swatch.title = `${color.code} (${color.bucket})`;
        swatch.style.backgroundColor = `rgb(${color.r}, ${color.g}, ${color.b})`;

        const codeLabel = document.createElement('div');
        codeLabel.className = 'ats-swatch-code';
        codeLabel.textContent = color.code;
        
        swatch.appendChild(codeLabel);
        return swatch;
      }

      selectColor(code) {
        const color = this.colorData.find(c => c.code === code);
        if (!color) return;

        this.colorInputReal.value = code;
        this.colorInputDisplay.value = code;
        
        // Crea il tile per l'anteprima
        this.selectedPreview.innerHTML = '';
        const previewSwatch = this.createSwatchElement(color);
        this.selectedPreview.appendChild(previewSwatch);
        
        this.inputGroup.classList.add('has-selection');
        
        sessionStorage.setItem(this.storageKey, code);
        this.updateSurcharge(code);
      }

      updateSurcharge(code) {
        if (!window.AtsSurchargeHandler) return;

        const color = this.colorData.find(c => c.code === code);
        if (!color) return;

        const variantSelector = document.getElementById(this.closest('section').querySelector('.product-variant-selects').id);
        const selectedOption = variantSelector.querySelector('input:checked, option:checked');
        const variantTitle = selectedOption ? (selectedOption.value || selectedOption.text) : '';

        const surchargeId = window.AtsSurchargeHandler.getSurchargeVariantId(color.bucket, variantTitle);
        this.surchargeInput.value = surchargeId || '';
        
        this.surchargeInput.dataset.bucket = color.bucket;

        if (window.AtsPriceManager) {
            window.AtsPriceManager.updateSurcharge(surchargeId);
            const surchargeCents = window.AtsPriceManager.surchargePrices[surchargeId] || 0;
            this.surchargeInput.dataset.surchargeEur = (surchargeCents / 100).toFixed(2) + ' €';
        }
      }

      clearSelection() {
        this.colorInputReal.value = '';
        this.colorInputDisplay.value = '';
        this.surchargeInput.value = '';
        this.selectedPreview.innerHTML = ''; // Pulisce l'anteprima
        delete this.surchargeInput.dataset.bucket;
        delete this.surchargeInput.dataset.surchargeEur;
        
        this.inputGroup.classList.remove('has-selection');
        sessionStorage.removeItem(this.storageKey);

        if (window.AtsPriceManager) {
            window.AtsPriceManager.resetSurcharge();
        }
      }

      restoreSelection() {
        const saved = sessionStorage.getItem(this.storageKey);
        if (saved) this.selectColor(saved);
      }

      openModal() {
        this.modalOverlay.classList.add('is-visible');
        document.body.style.overflow = 'hidden';
      }

      closeModal() {
        this.modalOverlay.classList.remove('is-visible');
        document.body.style.overflow = '';
      }
    }
  );
}
